<!-- <div class="contextmenu-section">
    <div id="contextmenu-control">
        <div id="contextmenutarget">{{content}}</div>
    </div>
</div> -->
<!-- <ejs-contextmenu #contextmenu [items]='menuItems' (beforeItemRender)='addDisabled($event)'
    (created)='onCreated()'></ejs-contextmenu> -->

<ejs-splitter *ngIf="!onDashboardCreationPage" #horizontal height='100%' separatorSize=4 width='100%'>
	<e-panes>
		<e-pane size='30%' min='5%'>
			<ng-template #content>
				<div id="treeContainer" class="tree-container" #treeContainer>
					<ejs-treeview id="treeview" [fields]="fields" [allowDragAndDrop]='allowDragAndDrop'
						(created)='show()' (dataBound)='hide()' (nodeSelected)="nodeSelected($event)"
						(nodeDragStop)="onDragStop($event)" (nodeDragStart)="onDragStart($event)"
						(nodeExpanded)="nodeExpanded($event)" (nodeCollapsed)="nodeExpanded($event)"
						(nodeClicked)='onNodeClicked($event)'>
						<ng-template #nodeTemplate="" let-data="">
							<div class="treeviewdiv">
								<mat-icon style="color: darkgoldenrod; float: left; margin-right: 5px;"
									*ngIf="!isParsableAsNumber(data.Uid) && !data.ParentUid">factory</mat-icon>
								<mat-icon style="color: darkgoldenrod; float: left; margin-right: 5px;"
									*ngIf="!isParsableAsNumber(data.Uid) && data.Expanded==false && data.ParentUid">folder</mat-icon>
								<mat-icon style="color: darkgoldenrod; float: left; margin-right: 5px;"
									*ngIf="!isParsableAsNumber(data.Uid) && data.Expanded==true && data.ParentUid">folder_opened</mat-icon>
								<mat-icon style=" float: left; margin-right: 5px;"
									*ngIf="isParsableAsNumber(data.Uid)">category</mat-icon>
								<div class="nodetext" [ngClass]="{'hidden': data.Hidden == true }">
									<span class="treeName">
										{{data.concatenatedText}}</span><span *ngIf="data.Hidden"> (HIDDEN)</span>
								</div>
								<div *ngIf="isParsableAsNumber(data.Uid)">
									<mat-icon *ngIf="assetIDsWithActiveRules.includes(data.AssetID)"
										style="color: red; margin-left: 5px;">notifications_active</mat-icon>
								</div>
							</div>
						</ng-template>
					</ejs-treeview>
				</div>
			</ng-template>
		</e-pane>
		<e-pane size='70%' min='5%'>
			<ng-template #content>
				<div class="splitter-content">
					<ng-container
						*ngIf="locationType == 'location' then LocationTemplate else AssetTemplate"></ng-container>
				</div>
			</ng-template>
		</e-pane>
	</e-panes>
</ejs-splitter>

<div *ngIf="onDashboardCreationPage" class="dashboard-tree-container">
	<div id="treeContainer" class="tree-container" #treeContainer>
		<ejs-treeview id="treeview" [fields]="fields" [allowDragAndDrop]='allowDragAndDrop' (created)='show()'
			(nodeDragStop)="dragIntoDashboard($event)" (dataBound)='hide()' (nodeExpanded)="nodeExpanded($event)"
			(nodeCollapsed)="nodeExpanded($event)">
			<ng-template #nodeTemplate="" let-data="">
				<div class="treeviewdiv">
					<mat-icon style="color: darkgoldenrod; float: left; margin-right: 5px;"
						*ngIf="!isParsableAsNumber(data.Uid) && !data.ParentUid">factory</mat-icon>
					<mat-icon style="color: darkgoldenrod; float: left; margin-right: 5px;"
						*ngIf="!isParsableAsNumber(data.Uid) && data.Expanded==false && data.ParentUid">folder</mat-icon>
					<mat-icon style="color: darkgoldenrod; float: left; margin-right: 5px;"
						*ngIf="!isParsableAsNumber(data.Uid) && data.Expanded==true && data.ParentUid">folder_opened</mat-icon>
					<mat-icon style=" float: left; margin-right: 5px;"
						*ngIf="isParsableAsNumber(data.Uid)">category</mat-icon>
					<div class="nodetext" [ngClass]="{'hidden': data.Hidden == true }">
						<span class="treeName">
							{{data.concatenatedText}}</span><span *ngIf="data.Hidden"> (HIDDEN)</span>
					</div>
					<div *ngIf="isParsableAsNumber(data.Uid)">
						<mat-icon *ngIf="assetIDsWithActiveRules.includes(data.AssetID)"
							style="color: red; margin-left: 5px;">notifications_active</mat-icon>
					</div>
				</div>
			</ng-template>
		</ejs-treeview>
	</div>
</div>

<ng-template #LocationTemplate>
	<app-hierarchy-manage-location (hierarchyChanged)="handleDataChanged($event)" [locationUID]="locationID"
		[hierarchyData]="hierarchicalData" [treeData]="treeData" [accountID]="accountID"
		[OrganisationID]="OrganisationID"></app-hierarchy-manage-location>
</ng-template>

<ng-template #AssetTemplate>
	<app-hierarchy-manage-asset (hierarchyChanged)="handleDataChanged($event)" [assetID]="locationID"
		[hierarchyData]="treeData" [accountID]="accountID"
		[OrganisationID]="OrganisationID"></app-hierarchy-manage-asset>
</ng-template>